import { render, staticRenderFns } from "./marketplaceModal.vue?vue&type=template&id=70ea36a3"
import script from "./marketplaceModal.vue?vue&type=script&lang=js"
export * from "./marketplaceModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2585860866/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70ea36a3')) {
      api.createRecord('70ea36a3', component.options)
    } else {
      api.reload('70ea36a3', component.options)
    }
    module.hot.accept("./marketplaceModal.vue?vue&type=template&id=70ea36a3", function () {
      api.rerender('70ea36a3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sites/marketplace/marketplaceModal.vue"
export default component.exports